import { useSnackbar } from 'notistack';
import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Reducers, Status } from '../Interfaces/Interfaces';
import { getAgentAccount, getBanks } from '../redux/actions/configActions';
import { createCashoutAccount } from '../redux/actions/CoordinatorActions';
import { resolveAccount } from '../redux/actions/FundsTransferActions';
import { createAccount } from '../redux/actions/userActions';
import PrimaryTheme from '../Themes/Primary';
import Input from './Input'

export default function SetUpCashoutAccount() {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const cashout = useSelector((state: Reducers) => state.cashout);
  const userType = useSelector((state: Reducers) => state.userType);
  const banks = useSelector((state: Reducers) => state.banks);
  const generic = useSelector((state: Reducers) => state.generic);
  const agent = useSelector((state: Reducers) => state.agentDetails);
  const loading = useSelector((state: Reducers) => state.loading);
  // const coordinatorType = useSelector((state: Reducers) => state.coordinatorType);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [bank, setBank] = React.useState("");
  const [bankArray, setBankArray]: any = React.useState([]);
  const [agentName, setAgentName] = React.useState('');
  const [agentPhoneNumber, setAgentPhoneNumber] = React.useState('');
  const [accountNumber, setAccountNumber] = React.useState('');
  const [accountName, setAccountName] = React.useState('');
  const [submitted, setSubmitted]: any = React.useState(false);
  const [agentId, setAgentId] = React.useState('');
  const [pin, setPin] = React.useState('');

  const handleSubmit = () => {

    let data = {
      pin,
      accountNumber,
      bankId: bankArray[0],
      accountName: generic.accountName,
      bankName: bankArray[1],
      agentId,
     

    }



    dispatch({
      type: 'LOADING',
      payload: true
    });

    if (userType === "5") {
      dispatch(createAccount(data))
    } else {
      dispatch(createCashoutAccount(data));
    }

  }


  const reset = () => {
    setAccountNumber('');
    setAccountName('');
    setPin('');
    setAgentPhoneNumber('');
    setAgentName('');
  }

  React.useEffect(() => {
    reset();

    console.log('came here');

  }, [])

  // check for institution changes and reset accountNumber
  React.useEffect(() => {
    setAccountNumber('');
    setAccountName('');
    let data = bank.split(',')
    setBankArray(data);

  }, [bank])

  // reset agent name on agent phoneNumber change
  React.useEffect(() => {
    setAgentName('');

  }, [agentPhoneNumber])

  React.useEffect(() => {
    setAccountName('');
    dispatch({
      type: 'GENERIC',
      payload: {}
    })

  }, [accountNumber, dispatch])

  React.useEffect(() => {
    if (Object.entries(generic).length !== 0) {
      setAccountName(generic.accountName);
    }

    if (Object.entries(agent).length !== 0) {
      setAgentName(agent.name);
      setAgentId(agent.id)
    }
  }, [generic, agent])

  React.useEffect(() => {
    if (accountNumber.length === 10) {
      let data = {
        bankId: bankArray[0],
        accountNumber
      }

      dispatch({
        type: 'LOADING',
        payload: true
      });

      dispatch(resolveAccount(data));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, accountNumber])

  React.useEffect(() => {
    if (agentPhoneNumber.length === 11) {

      dispatch({
        type: 'LOADING',
        payload: true
      });

      dispatch(getAgentAccount(agentPhoneNumber));
    }

    return () => {
      dispatch({
        type: 'AGENT_DETAILS',
        payload: {}
      });

      // reset();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, agentPhoneNumber])

  React.useEffect(() => {
    dispatch(getBanks());
   
    return () => {
      dispatch({
        type: 'GET_BANKS',
        payload: []
      })
    }
  }, [dispatch])
 
  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        // enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });

        setSubmitted(false);

      } else {

        enqueueSnackbar(alert.message, { variant: "success" });
        
        // setTimeout(() => {
        //   reset();

        //   history.push('/dashboard')
        // }, 5000)
        // handleRefresh();
       
        dispatch({
          type: "STATUS_ALERT",
          payload: true
        });

        dispatch({
          type: 'ALERT',
          payload: {}
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <div>
      <form autoComplete="off">
        <h5 className="mb-3 text-bold">Setup Cashout Account</h5>

        <div className="col-md-12 p-0">
          <label htmlFor="bankName" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
            textTransform: "uppercase"
          }}>Bank Name</label>

          <select
            className="custom-select"
            value={bank}
            disabled={loading}
            onChange={(e: any) => setBank(e.target.value)} style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              color: PrimaryTheme.dark,
              backgroundColor: "#F4F7FC",
              borderRadius: 25,
              border: '1px solid white',
              padding: 15,
              height: "auto",
              boxShadow: "none"
            }}>
            <option value="0">Select Bank</option>
            {banks && banks.map((item: Status, index: number) => (
              <option key={index} value={[item.id, item.name]}>{item.name}</option>
            ))}
          </select>
        </div>

        <div className="col-md-12 p-0">
          <label htmlFor="accountNumber" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
            textTransform: "uppercase"
          }}>Account Number</label>

          <Input
            type={"text"}
            inputMode="text"
            isInput
            disabled={loading}
            id="accountNumber"
            value={accountNumber}
            maxLength={10}
            onChange={(e) => setAccountNumber(e.target.value)}
            placeholder='Account Number'
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
            }} />
        </div>

        <div className="col-md-12 p-0">
          <label htmlFor="accountName" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
            textTransform: "uppercase"
          }}>Account Name</label>

          <Input
            type={"text"}
            inputMode="text"
            isInput
            disabled
            id="accountName"
            placeholder='Account Name'
            value={accountName}
            onChange={(e) => setAccountName(e.target.value)}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
              padding: '1.1rem',
              borderRadius: 100
            }} />
        </div>

        <h5 className="mb-3 text-bold mt-5">Setup Agent Account</h5>

        <div className="col-md-12 p-0">
          <label htmlFor="agentPhoneNumber" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
            textTransform: "uppercase"
          }}>Agent Phone Number</label>

          <Input
            type={"number"}
            inputMode="tel"
            isInput
            // disabled
            id="agentPhoneNumber"
            placeholder='Agent Phone Number'
            value={agentPhoneNumber}
            onChange={(e) => setAgentPhoneNumber(e.target.value)}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
            }} />
        </div>

        <div className="col-md-12 p-0">
          <label htmlFor="agentName" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
            textTransform: "uppercase"
          }}>Agent Name</label>

          <Input
            type={"text"}
            inputMode="text"
            isInput
            disabled
            id="agentName"
            placeholder='Agent Name'
            value={agentName}
            onChange={(e) => setAgentName(e.target.value)}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
            }} />
        </div>

        <div className="col-md-12 p-0">
          <label htmlFor="pin" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
            textTransform: "uppercase"
          }}>Enter Transaction PIN</label>

          <Input
            type={"password"}
            isPassword
            isInput
            id="pin"
            placeholder='* * * *'
            maxLength="4"
            size="4"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
            }} />
        </div>

        <div className="col-md-8 ml-auto mr-auto mb-0 text-center">

          <Input
            type="button"
            isInput
            id="submit"
            value={(submitted || loading) ? "Please wait..." : "Create"}
            disabled={submitted ||
              bank.length === 0 ||
              accountNumber === "" ||
              accountName === "" ||
              loading
            }
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikBold,
              backgroundColor: PrimaryTheme.primary,
              color: PrimaryTheme.white,
              padding: '1.1rem',
              borderRadius: 100
            }}
            onClick={handleSubmit}
          />

        </div>
      </form>

    </div>
  )
}
